const status = [
  { label: "Running", value: "running" },
  { label: "Queued", value: "queued" },
  { label: "Idle Timeout", value: "idle_timeout" },
  { label: "Queue Timeout", value: "queue_timeout" },
  { label: "Completed", value: "completed" },
  { label: "Passed", value: "passed" },
  { label: "Failed", value: "failed" },
  { label: "Error", value: "error" },
  { label: "Stopped", value: "stopped" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Lambda Error", value: "lambda error" }
  // { label: "Allocating VM", value: "initiated" }
];

const testStatus = [
  { label: "Running", value: "running" },
  { label: "Queued", value: "queued" },
  { label: "Idle Timeout", value: "idle_timeout" },
  { label: "Queue Timeout", value: "queue_timeout" },
  { label: "Completed", value: "completed" },
  { label: "Passed", value: "passed" },
  { label: "Failed", value: "failed" },
  { label: "Error", value: "error" },
  { label: "Stopped", value: "stopped" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Lambda Error", value: "lambda error" }
];

const buildStatus = [
  { label: "Running", value: "running" },
  // { label: "Queued", value: "queued" },
  { label: "Success", value: "success" },
  { label: "Error", value: "error" }
  // { label: "Success", value: "passed,completed" },
  // {
  //   label: "Error",
  //   value:
  //     "error,cancelled,stopped,failed,queue_timeout,idle_timeout,lambda error"
  // }
];

const buildType = [
  { label: "Selenium", value: "selenium" },
  { label: "Hypertest", value: "hypertest" },
  { label: "Cypress", value: "cypress" }
];

const countries = [
  { code: "AL", name: "Albania" },
  { code: "AD", name: "Andorra" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaijan" },
  { code: "BH", name: "Bahrain" },
  { code: "BD", name: "Bangladesh" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BR", name: "Brazil" },
  { code: "BG", name: "Bulgaria" },
  { code: "KH", name: "Cambodia" },
  { code: "CA", name: "Canada" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CO", name: "Colombia" },
  { code: "CR", name: "Costa Rica" },
  { code: "HR", name: "Croatia" },
  { code: "CW", name: "Curacao" },
  { code: "CY", name: "Cyprus" },
  { code: "CZ", name: "Czech Republic" },
  { code: "DK", name: "Denmark" },
  { code: "DO", name: "Dominican Republic" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "EE", name: "Estonia" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germany" },
  { code: "GR", name: "Greece" },
  { code: "GT", name: "Guatemala" },
  { code: "HN", name: "Honduras" },
  { code: "HK", name: "Hong Kong" },
  { code: "HU", name: "Hungary" },
  { code: "IS", name: "Iceland" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IE", name: "Ireland" },
  { code: "IM", name: "Isle of Man" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JM", name: "Jamaica" },
  { code: "JP", name: "Japan" },
  { code: "JO", name: "Jordan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KE", name: "Kenya" },
  { code: "KR", name: "Korea" },
  { code: "KW", name: "Kuwait" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LV", name: "Latvia" },
  { code: "LB", name: "Lebanon" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MY", name: "Malaysia" },
  { code: "MT", name: "Malta" },
  { code: "MX", name: "Mexico" },
  { code: "MD", name: "Moldova" },
  { code: "MN", name: "Mongolia" },
  { code: "MA", name: "Morocco" },
  { code: "NL", name: "Netherlands" },
  { code: "NZ", name: "New Zealand" },
  { code: "NI", name: "Nicaragua" },
  { code: "NG", name: "Nigeria" },
  { code: "NO", name: "Norway" },
  { code: "OM", name: "Oman" },
  { code: "PK", name: "Pakistan" },
  { code: "PA", name: "Panama" },
  { code: "PY", name: "Paraguay" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "PR", name: "Puerto Rico" },
  { code: "QA", name: "Qatar" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russian Federation" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "RS", name: "Serbia" },
  { code: "SG", name: "Singapore" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "ZA", name: "South Africa" },
  { code: "ES", name: "Spain" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "TW", name: "Taiwan" },
  { code: "TZ", name: "Tanzania" },
  { code: "TH", name: "Thailand" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Turkey" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VE", name: "Venezuela" },
  { code: "VN", name: "Vietnam" }
];

export const buildStatusMap = {
  running: "Running",
  queued: "Queued",
  idle_timeout: "Idle Timeout",
  queue_timeout: "Queue Timeout",
  completed: "Completed",
  passed: "Passed",
  failed: "Failed",
  error: "Error",
  stopped: "Stopped",
  cancelled: "Cancelled",
  "lambda error": "Lambda Error"
};

export const TestStatusMap = {
  ABORTED: "aborted",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
  ERROR: "error",
  FAILED: "failed",
  IDLE_TIMEOUT: "idle_timeout",
  INITIATED: "initiated",
  LAMBDA_ERROR: "lambda error",
  PASSED: "passed",
  PQUEUED: "pqueued",
  QUEUED: "queued",
  QUEUE_TIMEOUT: "queue_timeout",
  RUNNING: "running",
  STOPPED: "stopped",
  TIMEOUT: "timeout",
  SKIPPED: "skipped",
  UNKNOWN: "unknown",
  IGNORED: "ignored"
};

export const TestStatusNameMap = {
  aborted: "Aborted",
  cancelled: "Cancelled",
  completed: "Completed",
  error: "Error",
  failed: "Failed",
  idle_timeout: "Idle Timeout",
  initiated: "Initiated",
  "lambda error": "Lambda Error",
  passed: "Passed",
  pqueued: "Pqueued",
  queued: "Queued",
  queue_timeout: "Queue Timeout",
  running: "Running",
  stopped: "Stopped",
  timeout: "Timeout",
  skipped: "Skipped",
  unknown: "Unknown",
  ignored: "Ignored"
};

const TagFilterRegex = new RegExp(/,(?!\s)/); // substring which contain ',' which is not directly followed by ' '

export {
  status,
  buildType,
  countries,
  buildStatus,
  testStatus,
  TagFilterRegex
};
